import React from 'react';
import { formatDateForDisplay } from '../../utils/dateUtils';
import './MealTypeSelector.css';

const MealTypeSelector = ({ selectedDate, onMealTypeSelect, onBack, loading }) => {
  const mealTypes = [
    { 
      value: 'breakfast', 
      label: 'Breakfast', 
      icon: '🌅',
      description: 'Start your day right'
    },
    { 
      value: 'lunch', 
      label: 'Lunch', 
      icon: '☀️',
      description: 'Midday fuel'
    },
    { 
      value: 'dinner', 
      label: 'Dinner', 
      icon: '🌙',
      description: 'Evening meal'
    }
  ];

  const handleMealTypeClick = (mealType) => {
    if (loading) return;
    onMealTypeSelect(selectedDate, mealType);
  };

  const handleBackClick = () => {
    if (loading) return;
    onBack();
  };

  return (
    <div className="meal-type-selector">
      <div className="meal-type-header">
        <button 
          className="back-button"
          onClick={handleBackClick}
          disabled={loading}
        >
          ← Back
        </button>
        <div className="selected-date">
          <h4>Select meal type for:</h4>
          <p className="date-display">{formatDateForDisplay(selectedDate)}</p>
        </div>
      </div>

      <div className="meal-types-grid">
        {mealTypes.map((mealType) => (
          <button
            key={mealType.value}
            className="meal-type-button"
            onClick={() => handleMealTypeClick(mealType.value)}
            disabled={loading}
          >
            <span className="meal-icon">{mealType.icon}</span>
            <span className="meal-label">{mealType.label}</span>
            <span className="meal-description">{mealType.description}</span>
          </button>
        ))}
      </div>

      {loading && (
        <div className="loading-message">
          Scheduling recipe...
        </div>
      )}
    </div>
  );
};

export default MealTypeSelector;